import React from 'react';
import { Link } from 'react-router-dom';
import { RenderListItem } from '../../api/rendersApi';
import { storyDetailsPath } from '../../api/libraryPlayback';
import { useParentPreview } from '../../context/ParentPreviewContext';

/** The same parent actions for approved legacy and shared narration. */
export default function ApprovedStoryActions({ story, title, details = true }: { story: RenderListItem; title: string; details?: boolean }) {
  const preview = useParentPreview();
  const active = preview?.activeRender?.render_id === story.render_id;
  return <>
    <Link to="/story-time/setup" state={{ renderId: story.render_id }} className="btn btn-primary" aria-label={`Start story time with ${title}`}>Start story time</Link>
    <button type="button" className="btn btn-secondary" onClick={() => void preview?.handlePlay(story.render_id)} disabled={!preview || preview.loadingRenderId === story.render_id} aria-label={active && preview?.isPlaying ? `Pause ${title}` : `Play ${title}`}>
      {preview?.loadingRenderId === story.render_id ? 'Opening…' : active && preview?.isPlaying ? 'Pause preview' : 'Preview audio'}
    </button>
    {details && <Link to={storyDetailsPath(story)} className="btn btn-secondary" aria-label={`Open ${title}`}>Story details</Link>}
    {preview?.playErrorRenderId === story.render_id && <p role="alert">This story could not be opened. Try Preview audio again.</p>}
  </>;
}
